import React, { useState } from "react";

import TagMeetingHeader from "../components/TagMeetingHeader";
import ThankYouComponent from "../components/ThankYouComponent";
import DeleteUserComponent from "../components/DeleteUserComponent";

const DeleteUserPage = () => {
  const [showSuccess, setShowSuccess] = useState(false);

  return (
    <>
      <TagMeetingHeader headerName="Delete User" />
      {showSuccess ? (
        <ThankYouComponent message="User has been deleted successfully!" />
      ) : (
        <DeleteUserComponent setShowSuccess={setShowSuccess} />
      )}
    </>
  );
};

export default DeleteUserPage;
